import queryBuilder from '@glittr/frontend-core/src/plugins/validation/queryBuilder';
import validationPatterns from '@glittr/frontend-core/src/plugins/validation/validationPatterns';

export default {
  ...queryBuilder.properties({
    contactData: {
      type: 'object',
      properties: {
        salutation: { type: 'number', required: true },
        firstName: { type: 'string', required: true, maxLength: 30 },
        lastName: { type: 'string', required: true, maxLength: 150 },
        street: { type: 'string', required: true, maxLength: 50 },
        houseNumber: { type: 'string', required: true, maxLength: 30 },
        zipCode: { type: 'string', required: true, maximum: 2147483647 },
        city: { type: 'string', required: true, maxLength: 50 },
      },
    },
    communicationData: {
      type: 'object',
      properties: {
        email: { type: 'string', required: true, pattern: validationPatterns.email },
        phoneNumber: { type: 'string', required: true, pattern: validationPatterns.phone },
      },
    },
    communicationTime: { type: 'string', required: true },
    nimSLanguageId: { type: 'string', required: true },
  }),

  ...queryBuilder.if({ isGardenAddressNotContactDataAddress: true }),
  then: {
    ...queryBuilder.properties({
      gardenAddress: {
        type: 'object',
        properties: {
          street: { type: 'string', required: true, maxLength: 50 },
          houseNumber: { type: 'string', required: true, maxLength: 30 },
          zipCode: { type: 'string', required: true, maximum: 2147483647 },
          city: { type: 'string', required: true, maxLength: 50 },
        },
      },
    }),
  },
};
